import errorHandlerService from './errorHandler';

const requestService = (options, callback) => {
    const $script = $(document.getElementsByTagName('head')[0].firstChild);
    const requestTimeoutDuration = 40000;
    const jsonpName = `jsonp${Math.random()
        .toString()
        .replace('.', '')}`;

    let requestTimeout;

    const onError = (jqXHR, textStatus, errorThrown) => {
        if (textStatus === 'timeout' || textStatus === 'abort') {
            window[jsonpName] = () => {
                delete (window[jsonpName]);
            };
        }

        errorHandlerService(textStatus, {
            jqXHR,
            textStatus,
            errorThrown,
        });

        if (textStatus !== 'abort') {
            callback?.error?.(jqXHR, textStatus, errorThrown);
        }
    };

    const ajaxRequest = $.ajax($.extend({
        type: 'GET',
        dataType: 'json',
        jsonpCallback: jsonpName,
    }, options));

    ajaxRequest.done((response) => {
        clearTimeout(requestTimeout);

        if (response.success === true) {
            callback?.success?.(response);
        } else {
            errorHandlerService(response.message);
            callback?.error?.(response);
        }

        callback?.finally?.(response);
    });

    if (options.dataType !== 'jsonp') {
        ajaxRequest.fail(onError);

        return ajaxRequest;
    }

    $script[0].onerror = (e) => {
        clearTimeout(requestTimeout);
        ajaxRequest.readyState = 4;
        delete (window[jsonpName]);
        onError(e, null, $script.attr('src'));
    };

    requestTimeout = setTimeout(() => {
        $script[0].onerror = () => {};
        ajaxRequest.readyState = 4;
        onError($script, 'timeout', $script.attr('src'));
    }, requestTimeoutDuration);

    ajaxRequest.abort = () => {
        $script[0].onerror = () => {};
        clearTimeout(requestTimeout);
        onError($script, 'abort', $script.attr('src'));
    };

    return ajaxRequest;
};

export default requestService;
